import React, { useCallback, useMemo, useState } from 'react';
import * as api from '../api';
import Register from '../../hr/components/Register';

// Stephanet's Settings › Payers / Who Pays (catalog E("payers", …)): the funding entity of each site, with its share. The same payer list
// as Setup Rules › Who Pays, so it sits there.
export default function PayersRegister({ canEdit }) {
  const [sites, setSites] = useState([]);
  const load = useCallback(() => api.projects().then(r => {
    setSites(r.projects);
    const name = Object.fromEntries(r.projects.map(p => [String(p.site_id), p.name]));
    return r.payers.map(p => ({ ...p, site: name[String(p.site_id)] || null, status: p.is_active ? 'Active' : 'Inactive' }));
  }), []);
  const body = d => ({ name: d.name, site_id: d.site_id || null, bank_name: d.bank_name || null, account_number: d.account_number || null,
    share_pct: d.share_pct === '' || d.share_pct === undefined ? 100 : Number(d.share_pct), code: d.code || null, is_active: (d.status || 'Active') === 'Active' });
  const res = useMemo(() => ({
    key: 'payers', label: 'Payer', plural: 'Payers', title: r => r.name, load,
    create: d => api.savePayer(null, body(d)),
    update: (r, d) => api.savePayer(r.id, body({ ...r, ...d })),
    remove: r => api.deletePayer(r.id),
    search: ['name', 'site', 'bank_name', 'code'],
    defaults: { share_pct: 100, status: 'Active' },
    fields: [
      { name: 'name', label: 'Payer Entity', required: true, list: true },
      { name: 'site_id', label: 'Project Site', type: 'select', options: sites.map(s => ({ value: s.site_id, label: s.name })), list: false },
      { name: 'site', label: 'Project Site', list: true, form: false },
      { name: 'bank_name', label: 'Funding Bank', list: true },
      { name: 'account_number', label: 'Account No.' },
      { name: 'share_pct', label: 'Share %', type: 'number', list: true },
      { name: 'code', label: 'Code', list: true },
      { name: 'status', label: 'Status', type: 'select', options: ['Active', 'Inactive'], list: true },
    ],
  }), [load, sites]);
  return <Register res={res} compact canEdit={canEdit} />;
}
